const cardData = [
  {
    title: "Our Mission",
    description:
      "Our mission is to lead the global tourism industry by delivering innovative, reliable, and high-quality travel solutions that empower businesses to grow and succeed.",
    imageUrl: "images/aboutCard/1.jpg",
  },
  {
    title: "Our Vision",
    description:
      "To redefine the future of B2B tourism by creating smarter, more connected travel networks that empower businesses to grow and travelers to explore the world with confidence.",
    imageUrl: "images/aboutCard/2.jpg",
  },
  {
    title: "Our Values",
    description:
      "We believe in integrity, collaboration, and innovation. Every partnership we build is based on trust, transparency, and a shared drive to deliver exceptional experiences.",
    imageUrl: "images/aboutCard/3.jpeg",
  },
  {
    title: "Our Team",
    description:
      "A passionate group of professionals with deep expertise in tourism, technology, and customer service - united by one goal: helping our partners succeed in every journey.",
    imageUrl: "images/aboutCard/4.jpg",
  },
];
export default cardData;
